export default {
  "FlexCol": "_FlexCol_1rbrm_1",
  "Bureau": "_Bureau_1rbrm_9",
  "Drawer": "_Drawer_1rbrm_13",
  "Table": "_Table_1rbrm_18",
  "SubTitle": "_SubTitle_1rbrm_27",
  "ExtraMarginBottom": "_ExtraMarginBottom_1rbrm_33",
  "Testimonial": "_Testimonial_1rbrm_37"
};import "ni:sha-256;8jvLGVmKXOY0xx8-pielOoM7kQskaF--OvMOF0sHqb8";